import { Observable } from 'rxjs';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { select } from '@angular-redux/store';
import { StoreReducers } from '../../../../store/root.reducer';
import { StoreKeys } from '../../../models/store-keys';
import { BasketSelectStatus } from '../../../models/nexia-basket-object';
import { MailAzureService } from '../../../services/azure/mail/mail-azure.service';

@Component({
  selector: 'app-nexia-basket-objects-actions-button',
  templateUrl: './nexia-basket-objects-actions-button.component.html',
  styleUrls: ['./nexia-basket-objects-actions-button.component.scss']
})
export class NexiaBasketObjectsActionsButtonComponent implements OnInit {
  @select([StoreReducers.CONFIGURATION, StoreKeys.APPLICATION]) config$: Observable<any>;

  @Input()
  basketSelectStatus: BasketSelectStatus;

  @Input() actionsEnabled: boolean;

  @Input()
  screenWidth: number;

  @Input()
  hasDeleteAccess: boolean;
  @Input()
  hasHardDeleteAccess: boolean;

  @Output()
  download: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  downloadPdf: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  exportToExcel: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  downloadAnnotedPdf: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  delete: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  hardDelete: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  sendByEmail: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  removeFromBasket: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isMsAlConfigOk = false;
  BasketSelectStatus = BasketSelectStatus;

  constructor(private mailAzureService: MailAzureService) {}
  ngOnInit(): void {
    this.isMsAlConfigOk = this.mailAzureService.getIsMsAlConfig();
  }

  public onDownload(): void {
    this.download.emit(this.basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE);
  }
  public onDownloadPdf(): void {
    this.downloadPdf.emit(this.basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE);
  }
  public onExportToExcel(): void {
    this.exportToExcel.emit(this.basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE);
  }
  public onDownloadAnnotedPdf(): void {
    this.downloadAnnotedPdf.emit(this.basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE);
  }

  public onSendByEmail(): void {
    this.sendByEmail.emit(this.basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE);
  }

  public onRemoveFromBasket(): void {
    this.removeFromBasket.emit(this.basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE);
  }

  public onDelete(): void {
    this.delete.emit(this.basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE);
  }

  public onHardDelete(): void {
    this.hardDelete.emit(this.basketSelectStatus === BasketSelectStatus.SELECT_ACTIVE);
  }
}
